/* 🤖 this file was generated by svg-to-ts */
export const iconHuobiwallet: {
  name: 'huobiwallet';
  data: string;
} = {
  name: 'huobiwallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="currentColor" d="M18.5 11.09c0-3.04-1.5-5.66-2.64-6.51 0 0-.09-.05-.08.07-.09 5.87-3.13 7.47-4.8 9.61-3.85 4.95-.27 10.38 3.38 11.38 2.04.56-.47-1-.79-4.28-.39-3.96 4.94-6.99 4.94-10.28z"/><path fill="#fff" d="M20.12 13.05s-.06-.03-.08.01c-.06.74-.83 2.33-1.8 3.78-3.29 4.94-1.42 7.32-.36 8.6.61.74 0 0 1.53-.76a6.8 6.8 0 0 0 3.3-5.27c.2-2.41-.76-4.78-2.59-6.36"/></svg>`,
};
